import { render, staticRenderFns } from "./NewTBConclusion.vue?vue&type=template&id=15f0e72b&scoped=true"
import script from "./NewTBConclusion.vue?vue&type=script&lang=js"
export * from "./NewTBConclusion.vue?vue&type=script&lang=js"
import style0 from "./NewTBConclusion.vue?vue&type=style&index=0&id=15f0e72b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0e72b",
  null
  
)

export default component.exports